import { Link } from 'react-router-dom';
import {
  ORIGINES_HEADER_LEFT,
  ORIGINES_HEADER_RIGHT,
  ORIGINES_RESEAU_WIDE,
  ORIGINES_PORTRAIT,
  ORIGINES_FARMER,
  ORIGINES_IMPACT_BG,
} from '@config/assets';
import styles from './NosOrigines.module.css';

export default function NosOrigines() {
  return (
    <>
      {/* ── 1. Header ─────────────────────────────── */}
      <section className={styles.header}>
        <div className={styles.container}>
          <div className={styles.headerCopy}>
            <h1 className={styles.pageTitle}>Nos origines</h1>
            <p className={styles.pageSubtitle}>
              Une initiative née du terrain.{' '}
            </p>
          </div>

          <div className={styles.headerImages}>
            <div className={styles.headerImgLeftWrap}>
              <img
                src={ORIGINES_HEADER_LEFT}
                alt="Paysage agricole haïtien"
                className={styles.headerImg}
              />
            </div>
            <div className={styles.headerImgRightWrap}>
              <img
                src={ORIGINES_HEADER_RIGHT}
                alt="Carte du réseau Bohío Kiskeya"
                className={styles.headerImg}
              />
            </div>
          </div>
        </div>
      </section>

      {/* ── 2. Origin Story ───────────────────────── */}
      <section className={styles.story}>
        <div className={styles.container}>
          <div className={styles.storyBody}>
            <p>
              Né en 2019 dans la région du Bas Plateau, Bohío Kiskeya trouve son
              origine dans la volonté d&rsquo;agriculteurs de mieux valoriser
              leurs récoltes et de faciliter l&rsquo;accès aux marchés urbains.
            </p>

            <p>
              Face aux difficultés logistiques et à l&rsquo;isolement des zones
              de production, des producteurs se sont regroupés afin
              d&rsquo;organiser collectivement la circulation de leurs produits
              et de créer des débouchés plus stables. Cette initiative locale
              constitue aujourd&rsquo;hui la base d&rsquo;un réseau agricole en
              développement, engagé pour une agriculture structurée et durable,
              tout en contribuant à la souveraineté alimentaire en Haïti.
            </p>

            <p className={styles.storySubtitle}>
              Bohío Kiskeya&nbsp;: un nom porteur de sens
            </p>

            <p>
              Le nom Bohío Kiskeya rend hommage aux racines profondes de la
              terre haïtienne.
            </p>

            <p>
              Dans la langue taïno, parlée par les habitants originels de
              l&rsquo;île, bohío désigne la maison ou le lieu de vie commun.
              Plus qu&rsquo;un simple abri, il symbolise un espace de partage,
              de protection et d&rsquo;organisation collective.
            </p>

            <p>
              Kiskeya était quant à lui le nom donné à l&rsquo;île par ses
              premiers habitants, signifiant «&nbsp;terre de hautes
              montagnes&nbsp;». Ce nom évoque la richesse des paysages, la
              fertilité des terres et l&rsquo;histoire ancienne qui continue de
              façonner le territoire.
            </p>

            <p>
              En associant ces deux mots, Bohío Kiskeya incarne l&rsquo;idée
              d&rsquo;une maison commune dédiée à la terre haïtienne et à celles
              et ceux qui la cultivent. Le projet rend ainsi hommage à cet
              héritage en le faisant vivre au travers des femmes et des hommes
              qui, chaque jour, travaillent ces terres avec savoir-faire et
              engagement.
            </p>
          </div>
        </div>
      </section>

      {/* ── 3. CTA Buttons ────────────────────────── */}
      <section className={styles.cta}>
        <div className={styles.container}>
          <div className={styles.ctaButtons}>
            <Link to="/rejoindre" className={styles.btnBlack}>
              Rejoindre le réseau d&rsquo;agriculteurs
            </Link>
            <Link to="/partenaire" className={styles.btnGray}>
              Devenir partenaire
            </Link>
          </div>
        </div>
      </section>

      {/* ── 4. Notre réseau ───────────────────────── */}
      <section className={styles.reseau}>
        <div className={styles.container}>
          <h2 className={styles.sectionHeading}>Notre réseau</h2>

          <div className={styles.reseauRow}>
            <div className={styles.reseauCopy}>
              <p className={styles.reseauSubtitle}>
                Des femmes et des hommes engagés.
              </p>
              <p className={styles.reseauBody}>
                Agriculteurs, agronomes et partenaires locaux contribuent chaque
                jour au développement du réseau Bohío Kiskeya.
              </p>
            </div>

            <div className={styles.reseauWideWrap}>
              <img
                src={ORIGINES_RESEAU_WIDE}
                alt="Producteurs du réseau en action"
                className={styles.reseauWide}
              />
            </div>
          </div>

          <div className={styles.reseauImages}>
            <div className={styles.portraitWrap}>
              <img
                src={ORIGINES_PORTRAIT}
                alt="Échange de récoltes entre producteurs"
                className={styles.portrait}
              />
            </div>
            <div className={styles.farmerWrap}>
              <img
                src={ORIGINES_FARMER}
                alt="Agriculteur avec un panier de légumes"
                className={styles.farmer}
              />
            </div>
          </div>
        </div>
      </section>

      {/* ── 5. Impact de l'initiative ─────────────── */}
      <section className={styles.impact}>
        <div className={styles.container}>
          <h2 className={styles.sectionHeading}>
            Impact de l&rsquo;initiative
          </h2>

          <div className={styles.impactImageWrap}>
            <img
              src={ORIGINES_IMPACT_BG}
              alt="Impact du réseau Bohío Kiskeya – chiffres clés"
              className={styles.impactImage}
            />
          </div>
        </div>
      </section>
    </>
  );
}
